import React from "react";
import PropTypes from "prop-types";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import Header from "../component/Header";
import BottomNav from "../component/BottomNav";
import LendBook from "../component/LendBook";

import "../scss/library.scss";

import Category from './CategoryView';
import SVByYear from './sub/svbyyear';
import SVByPbblisher from './sub/svbypublisher';
import SVByAuthor from './sub/svbyauthor';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`tabpanel-${index}`}
			aria-labelledby={`tab-${index}`}
			{...other}
		>
			{children}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired
};

function a11yProps(index) {
	return {
		id: `tab-${index}`,
		"aria-controls": `tabpanel-${index}`
	};
}

export default function SimpleTabs(props) {

	//alert(JSON.stringify(props));

	var ncursel = 0;
	if (typeof props.location.state != 'undefined' && typeof props.location.state.cursel != 'undefined') {
		ncursel = props.location.state.cursel;
	}

	const [value, setValue] = React.useState(ncursel);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<React.Fragment>
			<Header />

			<Tabs value={value} onChange={handleChange} aria-label="tabs" variant="fullWidth">
				<Tab label="전체" {...a11yProps(0)} />
				<Tab label="연령별" {...a11yProps(1)} />
				<Tab label="출판사별" {...a11yProps(2)} />
				<Tab label="저자별" {...a11yProps(3)} />
			</Tabs>

			<TabPanel value={value} index={0}>
				<Category />
			</TabPanel>
			<TabPanel value={value} index={1}>
				<SVByYear />
			</TabPanel>
			<TabPanel value={value} index={2}>
				<SVByPbblisher />
			</TabPanel>
			<TabPanel value={value} index={3}>
				<SVByAuthor />
			</TabPanel>

			<BottomNav />
		</React.Fragment>
	);
}
